module.exports = __webpack_public_path__ + "img/img_sign.163fbf6b.png";